module.exports = __webpack_public_path__ + "img/main-logo.bc69de00.jpg";